const userData = {
  githubUsername: "nmrabet",
  avatarUrl: "/logo.svg",
  imgUrl: "/moi_pro.jpg",
  email: "nesrinemrabetnm@gmail.com",
  phone: "+33 6 34 30 97 43",
  projects: [
    {
      title: "Trader Square Staking",
      link: "https://demo.ts.open2be.com/",
      imgUrl: "trader-square.jpg",
      github: "",
    },
    {
      title: "Git Tower Landing Page",
      link: "https://git-tower.vercel.app/",
      imgUrl: "git-tower.jpg",
      github: "https://github.com/nmrabet/GitTower",
    },
    {
      title: "EO2 - Buy, Tokenize and Sell Carbon Certificates",
      link: "https://eo2.org/",
      imgUrl: "eo2-mock.jpg",
      github: "",
    },
  ],
  about: {
    title:
      "I'm a software developer that loves building products and web applications that impact lives",
    description: [
      `Although my career started in Communication and Marketing for about 7 years, which taught me excellent communication skills.`,
      `I've been developing React application for over 2 years now. My experience as a developer includes building responsive websites ranging from single-page applications to complex solutions with a focus on fast, elegant, and accessible user experiences.`,
      `Front-end development, HTML, CSS, JavaScript, and ReactJS are areas in which I am particularly proficient. Developing small and medium web apps, animations, and coding interface layouts.`,
      `As a Frontend Developer, I create thoughtful and inclusive experiences that adhere to web standards.`,
      `I've been coding in HTML5, CSS3, React.js, Next.js, Web3.js, Typescript, Node.js, Express.js, MongoDB, Bootstrap, TailwindCSS, etc to name a few. Although I barely know the syntax (Psst, Google!), I am getting pretty good at it.`,
    ],
    currentProject: "EOTWO Dapp",
    currentProjectUrl: "https://eo2.org/",
  },
  experience: [
    {
      title: "React Developer",
      company: "Techinked - Lewes, United-States (full remote)",
      year: "Jan 2022 - present",
      companyLink: "https://www.techinked.com/",
      desc: "Build & manage multiple product codebases using technologies like React.js, Next.js, Node.js, Express.js, TypeScript and more.",
    },
    {
      title: "React Developer",
      company: "Open2Be - Bordeaux, France (full remote)",
      year: "June 2021 - Dec 2021",
      companyLink: "https://www.open2be.com/",
      desc: "Development of user interfaces for DeFi (Decentralized Finance) Applications with Reactjs, Bootstrap, Typescript, Web3.js and Ether.js",
    },
    {
      title: "React Developer",
      company: "TouchDown Apps - Geneva, Switzerland (full remote)",
      year: "Dec 2020 - May 2021",
      companyLink: "",
      desc: "Design and architecture of SPAs using React,TypeScript,Tailwind, Git, HTML5 & CSS3. Integration of responsive design using Media-Queries, SASS and Tailwind",
    },
    {
      title: "Digital Marketing Consultant",
      company: "Meltwater - Paris, France (full remote)",
      year: "Dec 2019 - June 2020",
      companyLink: "https://www.meltwater.com/fr",
      desc: "In charge of writing, developing, editing, and publishing content for Meltwater digital's platforms, including blogs on Wordpress, SEO, videos, email marketing campaigns, advertising campaigns, social media posts, infographics, whitepapers, and more.",
    },
    {
      title: "Digital Marketing Manager",
      company: "Mediatech Producitons",
      year: "2015 - 2019",
      companyLink: "",
      desc: "Planning, developing, implementing and managing the overall digital marketing strategy of the company: Designing with adobe XD and developing the company's website and portfolio using HTML5, CSS3 & JavaScript. Designing the catalogs with Adobe Indesign, Photoshop & Illustrator. Products Photo Shoot. Motion Design Videos with Adobe After Effects",
    },
    {
      title: "Master degree in Digital Studies, Information & Communication",
      company: "University of Nice Sophia Antipolis - Nice, France.",
      year: "2012 - 2014",
      companyLink: "https://univ-cotedazur.fr/",
      desc: "Web development, SEO and copywriting",
    },
    {
      title: "Bachelor degree in Science of Information and Communication",
      company: "University of Nice Sophia Antipolis - Nice, France.",
      year: "2009 - 2012",
      companyLink: "https://univ-cotedazur.fr/",
      desc: "Design: Photoshop, Indesign, Illustrator. Digital Marketing & SEO. Web: HTML5, CSS3, Javascript.",
    },
    {
      title: "Baccalaureate ES",
      company: "Lycée Gustave Flaubert, La Marsa - Tunisie.",
      year: "2007",
      companyLink: "https://www.erlm.tn/lgf/",
      desc: "Economy Major",
    },
  ],
  resumeUrl:
    "https://drive.google.com/file/d/1xmE3BOmgM7TAOOgVp36xQIQvYDntDYoo/view?usp=sharing",
  socialLinks: {
    instagram: "https://instagram.com/nanouss0102",
    twitter: "https://twitter.com/nesrinemrabet",
    linkedin: "https://linkedin.com/in/nmrabet",
    github: "https://github.com/nmrabet",
    angellist: "https://angel.co/u/nesrine-mrabet",
  },
};

export default userData;
